/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   3/2/22
 */

import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {CalendarSettings} from "../../interfaces/Global";
import {persistState} from "../helpers";

export type SettingsState = CalendarSettings;

export const defaultSettings: SettingsState = {
	defaultView: "month",
	capacity: "availability",
	capacityThreshold: 80,
	groupBy: "off",
	showCountryFlags: true,
	filterTags: [],
	monthEventMinDurationHours: 4,
	displayGoogleEvents: true,
	displayVegaEvents: true,
	displayHolidays: true,
	displayOooEvents: true,
	displayOpsGenieEvents: true,
	displayWorkdayEvents: true,
	displayOverlapEvents: true,
	displayEmployeeBirthdays: true,
	displayEmployeeAnniversaries: true,
	displayEventTypes: [],
	tentativeEventsInCapacity: true,
	fractionalCapacityEnabled: true,
	groupHeaderEnabled: false,
	showBottomHeader: false,
	groupCapacityEnabled: true,
}

const STORAGE_KEY = 'vega.state.settings';
const storedState = localStorage.getItem(STORAGE_KEY);
const initialState: SettingsState = storedState ? JSON.parse(storedState) : defaultSettings;

export const slice = createSlice({
	name: 'settings',
	initialState: { ...defaultSettings, ...initialState },
	reducers: {
		set: (state, action: PayloadAction<SettingsState>) => {
			const newState = action.payload;
			persistState(STORAGE_KEY, newState);
			return newState;
		},
		update: (state: SettingsState, action: PayloadAction<Partial<SettingsState>>) => {
			const newState = { ...state, ...action.payload };
			persistState(STORAGE_KEY, newState);
			return newState;
		}
	}
});

export const {set, update} = slice.actions;
export default slice.reducer;